import convertHexToRgbA from "./convertHexToRgbA";
import getImageQrCodeBase64 from "./getImageQrCodeBase64";
import { jsPDF } from "jspdf";
import env from "../env";
import logo_oficinal_unjbg from "../assets/images/logo_oficinal_unjbg.png";
import photoParticipant from "../assets/images/photo-participant.jpg";
import {
  FONT_ROBOTO_REGULAR_BASE64,
  FONT_ROBOTO_MEDIUM_BASE64,
  FONT_ROBOTO_BOLD_BASE64
} from "../constants/fontsInBase64";

// esta se usa para la credencial

// const INSTITUTIONAL_RED_COLOR_HEX = "#d41d3d";
// const INSTITUTIONAL_ROSA_COLOR_HEX = "#E88795";

const NOMBRE_PROCESO_DE_ADMISION = `EXAMEN DE ADMISIÓN ${env("REACT_APP_NOMBRE_PROCESO")}`;
// const NOMBRE_UNIVERSIDAD = "UNIVERSIDAD NACIONAL JORGE BASADRE GROHMANN";

const generateCredentialBase64 = async (
  user = {
    nombre: "Docente",
    apellido: "Docente Docente",
    correlativo: "2023001",
    nrodocumento: "71460218",
    tipoparticipacion: "",
    color: "#D41D3D",
    fotoParticipante: ""
  }
) => {
  const callAddFont = function () {
    this.addFileToVFS("Roboto-bold.ttf", FONT_ROBOTO_BOLD_BASE64);
    this.addFont("Roboto-bold.ttf", "Roboto", "bold");
    this.addFileToVFS("Roboto-normal.ttf", FONT_ROBOTO_REGULAR_BASE64);
    this.addFont("Roboto-normal.ttf", "Roboto", "normal");
    this.addFileToVFS("Roboto-Medium.ttf", FONT_ROBOTO_MEDIUM_BASE64);
    this.addFont("Roboto-Medium.ttf", "Roboto", "normal", "500");
  };
  jsPDF.API.events.push(["addFonts", callAddFont]);

  const convertColorHexToRGB = (color = "#FFFFFF") => {
    const rgba = convertHexToRgbA(color);
    return rgba.array;
  };

  const generatePDF = (user = {}, qrImageUrl = "") => {
    return new Promise((resolve, reject) => {
      const correlativeCode = user.correlativo.toLocaleUpperCase() || "";

      let userName = user.nombre || "";
      userName = userName.toLocaleUpperCase();

      let userLastName = user.apellido || "";
      userLastName = userLastName.toLocaleUpperCase();

      const userDni = user.nrodocumento || "";
      const tipoparticipacion = user.tipoparticipacion || "";

      const fotoParticipante = user.fotoParticipante || photoParticipant;

      const [ubr = 32, ubg = 32, ubb = 34] = convertColorHexToRGB(user.color);

      let coordinateYCounter = 1;
      let coordinateXcounter = 1;

      const doc = new jsPDF({
        orientation: "p",
        unit: "cm",
        format: [9.2, 12.5]
      });

      let width = 9.2;
      let height = 12.5;

      // Contenedor parte superior
      coordinateYCounter = 0;
      coordinateXcounter = 0;
      const positionParticipantNameWidth = width / 4;
      const positionParticipantNameHeight = height;
      doc.setFillColor(ubr, ubg, ubb);
      doc.roundedRect(
        coordinateXcounter,
        coordinateYCounter,
        positionParticipantNameWidth,
        positionParticipantNameHeight,
        0,
        0,
        "F"
      );

      // Nombre UNJBG
      // coordinateYCounter = 0.6;
      // coordinateXcounter = width / 2;
      // doc.setFont("Roboto", "normal", "bold");
      // doc.setFontSize(10);
      // doc.setTextColor(0, 0, 0);
      // var splitTitle = doc.splitTextToSize(NOMBRE_UNIVERSIDAD, 16);
      // doc.text(splitTitle, coordinateXcounter, coordinateYCounter, {
      //   maxWidth: 5,
      //   align: "center"
      // });

      for (let i = 1; i < 3; i = i + 0.5) {
        for (let j = 8.6; j > 7.6; j = j - 0.4) {
          coordinateYCounter = i;
          coordinateXcounter = j;
          doc.setFontSize(10);
          doc.setTextColor(0, 0, 0);
          doc.text(".", coordinateXcounter, coordinateYCounter, {
            align: "center",
            angle: 90
          });
        }
      }

      // Imagen logo UNJBG
      coordinateYCounter = 2.5;
      coordinateXcounter = width / 2.8;
      doc.addImage(
        logo_oficinal_unjbg,
        "png",
        coordinateXcounter,
        coordinateYCounter - 2,
        3.5,
        1.9,
        "foto",
        "MEDIUM",
        0
      );

      // Nombre participación
      // ------- THIS -------
      coordinateYCounter = 10;
      coordinateXcounter = 1.2;
      doc.setFontSize(14);
      doc.setTextColor(255, 255, 255);
      var splitTitle = doc.splitTextToSize(tipoparticipacion, 16);
      doc.text(splitTitle, coordinateXcounter, coordinateYCounter, {
        maxWidth: 8,
        align: "left",
        angle: 90
      });

      // Nombre proceso de admisión a la izquierda
      coordinateYCounter = 12.2;
      coordinateXcounter = 12.6;
      doc.setFontSize(8);
      doc.setFont("Roboto", "normal", "bold");
      doc.setTextColor(132, 134, 136);
      doc.text(NOMBRE_PROCESO_DE_ADMISION, coordinateXcounter, coordinateYCounter, {
        align: "center",
        angle: 90
      });

      // Foto participante
      coordinateYCounter = 3;
      coordinateXcounter = width / 2.5;
      const widthPhotoParticipant = 3.5;
      const heightPhotoParticipant = 4.5;
      doc.addImage(
        fotoParticipante,
        "JPEG",
        coordinateXcounter,
        coordinateYCounter,
        widthPhotoParticipant,
        heightPhotoParticipant,
        "photo-participant",
        "MEDIUM",
        0
      );

      // Nombre de participante
      coordinateYCounter = 8.3;
      coordinateXcounter = width / 1.7;
      doc.setFont("Roboto", "normal", "bold");
      doc.setFontSize(13);
      doc.setTextColor(32, 32, 34);
      doc.text(userName, coordinateXcounter, coordinateYCounter, "center");

      // Apellidos de participante
      coordinateYCounter += 0.6;
      coordinateXcounter = width / 1.7;
      doc.setFont("Roboto", "normal", "bold");
      doc.setFontSize(13);
      doc.setTextColor(32, 32, 34);
      doc.text(userLastName, coordinateXcounter, coordinateYCounter, "center");

      // Contenedor franja derecha
      // coordinateYCounter = 9.2;
      // coordinateXcounter = 6.6;
      // const positionParticipantNameWidth = width / 3.2;
      // const positionParticipantNameHeight = 1.8;
      // doc.setFillColor(ubr, ubg, ubb);
      // doc.roundedRect(
      //   coordinateXcounter,
      //   coordinateYCounter,
      //   positionParticipantNameWidth,
      //   positionParticipantNameHeight,
      //   0.25,
      //   0.25,
      //   "F"
      // );

      // DNI participante
      coordinateYCounter = 9.8;
      coordinateXcounter = width / 1.66;
      doc.setFont("Roboto", "normal", "bold");
      doc.setFontSize(16);
      doc.setTextColor(ubr, ubg, ubb);
      doc.text(`${userDni}`, coordinateXcounter, coordinateYCounter, {
        align: "center"
      });

      //QR image
      coordinateYCounter = 12.2;
      coordinateXcounter = width / 2;
      const QR_IMAGE_SIZE = 1.9;
      doc.addImage(
        qrImageUrl,
        "png",
        coordinateXcounter,
        coordinateYCounter - 2,
        QR_IMAGE_SIZE,
        QR_IMAGE_SIZE,
        "qr",
        "MEDIUM",
        0
      );

      // Correlativo
      coordinateYCounter = 12;
      coordinateXcounter = 1;
      doc.setFont("Roboto", "normal", "bold");
      doc.setFontSize(18);
      doc.setTextColor(255, 255, 255);
      doc.text(correlativeCode, coordinateXcounter, coordinateYCounter, {
        align: "center"
      });

      const dataUrlBase64 = doc.output("datauristring");
      resolve(dataUrlBase64);
    });
  };

  try {
    const userDni = user.nrodocumento;
    const qrText = userDni;
    const qrImageUrl = await getImageQrCodeBase64(qrText, 250, "L", "#000000", "#FFFFFF");
    const credentialBase64 = await generatePDF(user, qrImageUrl);

    return credentialBase64;
  } catch (error) {
    console.log(error);
  }
};

export default generateCredentialBase64;
